import { render } from "./EditStop.vue?vue&type=template&id=5bd854b1"
import script from "./EditStop.vue?vue&type=script&lang=js"
export * from "./EditStop.vue?vue&type=script&lang=js"
script.render = render

export default script